import moment_ from "moment"
import "moment/locale/de-at"

moment_.locale("de")

export const moment = moment_

// https://momentjs.com/docs/#/displaying/format/
export const parseDate = (date) => date ? moment(date, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY"]) : null